export const gitCommit = 'b8b2bf0b'
